module.exports = __webpack_public_path__ + "static/media/download-from-cloud.23c5bb4c.png";